export default __webpack_public_path__ + "static/media/RegioStore_Logo_Location.b75026e0.png";